import React from 'react';

import { useQuery } from '@tanstack/react-query';

import OnboardingItem from './OnboardingItem';

import LoanService from '../../../../../services/LoanService';

export default function Onboarding({ loanId }) {
  const { data: onboardingData, refetch } = useQuery({
    queryKey: ['getLoanOnboarding', loanId],
    queryFn: () => LoanService.getLoanOnboarding(loanId),
  });

  const onboarding = onboardingData?.onboarding || [];

  const sortedOnboarding = onboarding.sort((a, b) => {
    return a.sequence - b.sequence;
  });

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10 relative">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6 flex justify-between w-full">
        Onboarding
      </h2>
      <ul className="flex flex-col gap-4">
        {sortedOnboarding?.map((item) => (
          <li key={item.id}>
            <OnboardingItem item={item} refetch={refetch} loanId={loanId} />
          </li>
        ))}
      </ul>
    </div>
  );
}
